export * from '../patrocinador/list/patrocinadorList.component';
export * from '../patrocinador/create/patrocinadorCreate.component';
export * from '../patrocinador/edit/patrocinadorEdit.component';
export * from '../patrocinador/detail/patrocinadorDetail.component';
export * from '../patrocinador/search/patrocinadorSearch.component';